import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {ProtocolOptions as Component} from './ProtocolOptions';

import {
  setNoteBookSection,
  incProtocolPage,
  decProtocolPage,
  goProtocolPage,
  setPageInstructions,
  toggleNotesView,
  setTotalProtocolPages,
  focusFirstTask,
  setModal,
  showModal,
  startTour
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    sectionOption: getSectionOption(state.notebook),
    currentPage: state.notebook.protocolSection.scene.currentProtocolPage,
    totalPages: state.notebook.protocolSection.scene.totalProtocolPages,
    pageInstructions: state.notebook.protocolSection.scene.currentPageInstructions,
    focusedTask: state.notebook.protocolSection.scene.focusedTask,
    focusedPage: state.notebook.protocolSection.scene.focusedPage,
    taskPages: state.notebook.protocolSection.scene.taskPages,
    notesView: state.notebook.protocolSection.scene.notesView,

    level: state.notebook.protocolSection.scene.level,
    modalsShown: state.notebook.protocolSection.scene.modal.shown,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // notebookSection: (data) => {
    //   dispatch(notebookSection(data))
    // },

    focusFirstTask: (data) => {
      dispatch(focusFirstTask(data))
    },
    setNoteBookSection: (sectionValue) => {
      dispatch(setNoteBookSection(sectionValue));
    },
    incProtocolPage: (data) => {
      dispatch(incProtocolPage(data))
    },
    decProtocolPage: (data) => {
      dispatch(decProtocolPage(data))
    },
    goProtocolPage: (data) => {
      dispatch(goProtocolPage(data))
    },
    setPageInstructions: (data) => {
      dispatch(setPageInstructions(data))
    },
    setTotalProtocolPages: (data) => {
      dispatch(setTotalProtocolPages(data))
    },
    toggleNotesView: (data) => {
      dispatch(toggleNotesView(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    startTour: (data) => {
      dispatch(startTour(data))
    }
  };
}

const getSections = (notebook) => notebook.sections;
const getSectionOption = createSelector([getSections], (sections) =>
  sections.find((section) => section.current)
);

export const ProtocolOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
